<template>
    <!--
        You may use this event to toggle the expansion of the card (see example)
        @event card-click
    -->
    <div
        :class="cardStatus"
        @click="e => $emit('card-click', e)"
    >
        <div
            v-if="!isLoading"
            :class="{
                'BaseCard__card': true,
                'BaseCard__card--expanded': open
            }"
        >
            <slot name="cardContent">
                <!--
                    @slot Slot to add an icon to the beginning of the card
                -->
                <div
                    v-if="hasLeadingIcon"
                    class="BaseCard__icon-container"
                >
                    <slot name="leadingIcon"></slot>
                </div>
                <!--
                    @slot You can optionally replace the entire title container,
                    instead of just the title and subtitle individually.
                -->
                <slot name="title-container">
                    <div class="BaseCard__title-container">
                        <!-- @slot Replace the default card title HTML -->
                        <slot name="title">
                            <span class="BaseCard__title">{{ title }}</span>
                        </slot>
                        <!-- @slot Replace the default card subtitle HTML -->
                        <slot name="subtitle">
                            <span
                                v-if="subtitle !== ''"
                                class="BaseCard__subtitle"
                            >{{ subtitle }}</span>
                        </slot>
                    </div>
                </slot>
                <div class="BaseCard__placeholder"></div>
                <div class="BaseCard__action-container">
                    <!-- @slot Default card content -->
                    <slot />
                </div>
            </slot>
        </div>
        <div
            v-if="open"
            class="BaseCard__expanded"
        >
            <!-- @slot Content to display when the card is expanded -->
            <slot name="expanded"></slot>
        </div>
    </div>
</template>
<script>
import stat from 'status/index';
import statusBuilder from 'status/statusBuilder';
export default {
    name: 'RPBaseCard',
    props: {
        /**
         * Card title
         */
        title: {
            type: String,
            default: '',
        },
        /**
         * Card subtitle
         */
        subtitle: {
            type: String,
            default: '',
        },
        status: {
            type: String,
            default: stat.STANDBY
        },
        open: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        isLoading(){
            return this.status === stat.LOADING;
        },
        cardStatus(){
            return statusBuilder('BaseCard', this.status);
        },
        hasLeadingIcon(){
            return !!this.$slots.leadingIcon;
        },
    }
};
</script>
<style lang="scss">
    .BaseCard {
        width: 100%;
        background: $white;
        border-radius: 4px;
        box-shadow: 0 2px 5px rgba(0, 0, 0, 0.08);
        margin-bottom: 1rem;
        padding: 1px;
        display: flex;
        flex-direction: column;

        @include loading(4rem, 100%);

        &--saving { background-image: $gradient-purple; }
        &--success { background-image: $gradient-positive; }
        &--warning { background-image: $gradient-yellow; }
        &--error { background-image: $gradient-negative; }

        &__card {
            width: 100%;
            background: $white;
            border-radius: 4px;
            padding: 1rem;
            display: flex;
            align-items: center;
            justify-content: space-between;

            &--expanded {
                border-bottom-left-radius: 0;
                border-bottom-right-radius: 0;
            }
            &--transparent {
                background: transparent;
            }
        }

        &__icon-container {
            margin-right: 0.5rem;
            display: flex;
            align-items: center;
        }

        &__title-container {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
        }
        &__title {
            font-weight: 600;
            margin-bottom: 0.25rem;
        }
        &__subtitle{
            color: $grey
        }
        &__placeholder {
            flex-grow: 1;
        }
        &__action-container {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
        }
        &__expanded {
            width: 100%;
            background: $white;
            padding: 1rem 1rem 1rem 1rem;
            border-top: 1px solid $grey-75;

            border-bottom-left-radius: 4px;
            border-bottom-right-radius: 4px;
        }
    }
</style>

<docs>
```vue
import stat from 'status/index';

<RPBaseCard
    :open="myValBoolean"
    @card-click="myValBoolean = !myValBoolean"
    title="Card Title"
    subtitle="Subtitle"
>
    <template v-slot:default>
        <div>
            <p>Default slot content.</p>
            <p>Maecenas facilisis fermentum elit posuere adipiscing ante sociosqu accumsan, dis turpis parturient at ad praesent tincidunt curabitur purus, class venenatis lorem non pharetra volutpat rhoncus.</p>
        </div>
    </template>
    <template v-slot:expanded>
        <div>
            <p>Expanded card slot content.</p>
            <p>Netus interdum curae auctor primis cubilia ad sem ornare mi aenean, vehicula fermentum commodo convallis nulla euismod felis sit porta conubia, eget hac consectetur dictum potenti congue blandit aptent suscipit.</p>
        </div>
    </template>
</RPBaseCard>
```
</docs>
